<template>
  <img class="position-absolute z-low obj lax lax_preset_slideX:706:-415" src="../assets/photo/landing/obj1.png" alt="" />
  <img class="position-absolute z-low obj lax lax_preset_slideY:706:-415" src="../assets/photo/landing/obj2.png" alt="" />
  <img class="position-absolute z-low obj lax lax_preset_slideX:706:715" src="../assets/photo/landing/obj1.png" alt="" />
  <img class="position-absolute z-low obj lax lax_preset_seesaw:140:20" src="../assets/photo/landing/obj3.png" alt="" />
  <img class="position-absolute z-low obj lax lax_preset_scaleIn:98:0.8" src="../assets/photo/landing/obj5.png" alt="" />
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
